import { ModalProvider } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { getProduct, Scheme, useConfig } from '../../state/configuration'
import { AppPath } from '../AppPath'
import { ProtectedRoutes } from '../authentication'
import { DirectDebitCallbackWrapper } from '../organisms/billing'
import { PolicyManager } from './policy'
import { PolicyPath } from './policy/PolicyPath'
import { ProductContext } from './ProductProvider'
import { CreateProposal, ProposalManager } from './proposal'
import { ProposalPath } from './proposal/ProposalPath'
import { ProposalRouter } from './proposal/ProposalRouter'
import { RefreshAnonymous } from './RefreshAnonymous'
import { RenewalRouter } from './renewal/RenewalRouter'

export interface ProductRouterProps {
  scheme: Scheme
}

export const ProductRouter: FunctionComponent<ProductRouterProps> = ({ scheme }) => {
  const product = useConfig(getProduct(scheme.schemeCode))

  return (
    <DirectDebitCallbackWrapper>
      <ProductContext.Provider value={{ scheme, product }}>
        <ModalProvider>
          <Routes>
            <Route
              index
              element={
                <RefreshAnonymous>
                  <CreateProposal />
                </RefreshAnonymous>
              }
            />

            <Route
              path={ProposalPath.RENEWAL + AppPath.WILDCARD}
              element={
                <ProtectedRoutes preservePath={true}>
                  <ProposalManager>
                    <RenewalRouter />
                  </ProposalManager>
                </ProtectedRoutes>
              }
            />

            <Route
              path={ProposalPath.PROPOSAL + AppPath.WILDCARD}
              element={
                <ProposalManager>
                  <ProposalRouter />
                </ProposalManager>
              }
            />

            <Route
              path={PolicyPath.POLICY + AppPath.WILDCARD}
              element={
                <ProtectedRoutes preservePath={true}>
                  <PolicyManager />
                </ProtectedRoutes>
              }
            />

            <Route path='*' element={<Navigate to={AppPath.HOME} />} />
          </Routes>
        </ModalProvider>
      </ProductContext.Provider>
    </DirectDebitCallbackWrapper>
  )
}
